<template>
	<div class="sv-preview">
		<img :src="image" :style="style"/>
		<i v-if="isDeleteButtonShow" class="far fa-trash-alt remove-button" @click.prevent="onDeleteClick"></i>
	</div>
</template>

<script>

export default {
	name: 'Preview',
	props: {
		image: {
			type: String,
			default: '',
		},
		maxH: {
			type: Number,
			default: 90,
		},
		isDeleteButtonShow: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		style: function() {
			return {
				'max-height': this.maxH + 'px',
			};
		},
	},
	methods: {
		onDeleteClick: function() {
			this.$utils.log('onDeleteClick');
			this.$emit('delete-click');
		},
	},
}
</script>

<style lang="scss">
.sv-preview {
	display: inline-block;
	position: relative;

	img {
		width : auto;
		max-width: 100%;
		height: auto;
		max-height: 200px;
		margin: 0 auto;
		vertical-align: bottom;
	}

	.remove-button {
		background: #000000aa;
		color: #fff;
		padding: 10px;
		font-size: 1.2rem;
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
		display: block;
	}
}

</style>
